import React from 'react';
import moment from 'moment-timezone';
import { Range } from 'immutable';
import TimeUtil from 'time';
import TimeDisplayTypes from 'shared/constants/TimeDisplayTypes';
import VerticalValueSelector from 'shared/components/form/verticalValueSelector.jsx';

/**
 * Basic Preset Duration Picker
 *
 */
const PresetDurationPicker = React.createClass({
  displayName: 'PresetDurationPicker',

  propTypes: {
    value: React.PropTypes.number.isRequired,
    showSuppressionToggle: React.PropTypes.bool,
    isSuppressed: React.PropTypes.bool,
    onSuppressionChanged: React.PropTypes.func,
    onRunTimeSuppressionChanged: React.PropTypes.func,
    onClose: React.PropTypes.func,
    showResetButton: React.PropTypes.bool,
    onResetClicked: React.PropTypes.func,
    buttonsComponent: React.PropTypes.element,
    hasShowcaller: React.PropTypes.bool,
    mobile: React.PropTypes.bool,
    displayType: React.PropTypes.string,
  },

  getInitialState() {
    return {
      originalValue: this.props.value,
    };
  },

  render() {
    const {
      value,
      // mobile,
      displayType,
    } = this.props;

    const positiveValue = value > 0 ? value : 0;

    let duration = moment.duration(positiveValue, 'seconds');

    // Hours
    const hours = duration.hours();
    duration = hours ? duration : duration.subtract(hours, 'hours');

    // Minutes
    let minutes = duration.minutes();

    if (displayType !== TimeDisplayTypes.sixDigitTime) {
      minutes =
        value === 0 ? duration.minutes() : Math.floor(duration.asMinutes());
    }

    duration = minutes ? duration : duration.subtract(minutes, 'minutes');

    // Seconds
    const seconds = duration.seconds();
    // let durationClasses = 'duration-picker';

    // let durationClass = 'humanized-time';
    // let maxDurationMinuteValue = 60;

    let presetClass = 'preset-time';
    let maxPresetMinuteValue = 1440;
    if (displayType === TimeDisplayTypes.sixDigitTime) {
      presetClass = 'six-digit-time';
      maxPresetMinuteValue = 60;
    }
    if (displayType === TimeDisplayTypes.clockTime) {
      presetClass = 'clock-time';
    }

    return (
      <span className={presetClass}>
        {displayType === TimeDisplayTypes.sixDigitTime
          ? this._getSelectorNode('h', hours, 24, (value) =>
              this._handleChange('hours', value),
            )
          : null}
        {this._getSelectorNode('m', minutes, maxPresetMinuteValue, (value) =>
          this._handleChange('minutes', value),
        )}
        {this._getSelectorNode('s', seconds, 60, (value) =>
          this._handleChange('seconds', value),
        )}
      </span>
    );
  },

  _getSelectorNode(prefix, value, max, onChange) {
    const {
      mobile,
      // pickerType,
      // durationDisplayType,
      displayType,
      onClose,
      onTab,
    } = this.props;

    let fourDigitMinuteField = false;

    if (
      displayType === TimeDisplayTypes.clockTime ||
      displayType === TimeDisplayTypes.presetTime
    ) {
      fourDigitMinuteField = true;
    }

    const options = Range(0, max);

    let inputLength = 2;

    if (prefix === 'm' && fourDigitMinuteField) {
      inputLength = 4;
    }

    const focus = fourDigitMinuteField ? 'm' : 'h';

    return (
      <VerticalValueSelector
        initialFocus={prefix === focus}
        textInput
        typePrefix={prefix}
        mobile={mobile}
        onBlur={onClose}
        onTab={onTab}
        onChange={onChange}
        options={options}
        displayValue={TimeUtil.getFormattedDurationField(value)}
        value={value}
        length={inputLength}
      />
    );
  },

  _handleChange(type, amount) {
    const { value, displayType } = this.props;

    const positiveValue = value > 0 ? value : 0;

    const oldDuration = moment.duration(positiveValue, 'seconds');
    let newDuration = moment.duration(parseInt(amount, 10), type);

    const oldHours = oldDuration.hours();
    const oldMins = oldDuration.minutes();
    const oldSeconds = oldDuration.seconds();

    let oldHourDuration = moment.duration(oldHours, 'hours');
    const oldMinDuration = moment.duration(oldMins, 'minutes');
    const oldSecDuration = moment.duration(oldSeconds, 'seconds');

    if (type === 'minutes' && displayType !== TimeDisplayTypes.sixDigitTime) {
      oldHourDuration = 0;
    }

    /**
     * Sets all time fields to 0 when a preset time is
     * selected except preset that was checked
     */
    if (type === 'hours') {
      newDuration = newDuration.add(oldMinDuration).add(oldSecDuration);
    } else if (type === 'minutes') {
      newDuration = newDuration.add(oldHourDuration).add(oldSecDuration);
    } else if (type === 'seconds') {
      newDuration = newDuration.add(oldHourDuration).add(oldMinDuration);
    }
    this.props.onChange(newDuration.asSeconds());
  },
});

export default PresetDurationPicker;
